import type { FaireProductEntity } from "../../entity_types/product";

export const p_v4he624zc8: FaireProductEntity = {
  token: "p_v4he624zc8",
  type: "product",
  name: "Crystal Confetti Mix - 5 Pounds",
  brandToken: "b_eqykpyrhjx",
  brandName: "The Healing Sanctuary",
  imageUrl:
    "https://cdn.faire.com/fastly/fabb69c6d7c1a42e39d0c3df0a57bd81fe8fa23ff3879efb1f468d8d2eb2cd1a.jpeg",
  galleryImageUrls: [],
  priceDollars: 55,
  description:
    "You will receive 5 Pounds of crystal confetti\n\n*Crystals comes from Mother Earth, there will be slight variations for each stone, color, size, shape, etc. All metaphysical information given by The Healing Sanctuary is for spiritual purposes only.\n\n*Each and every crystal shipped from us is blessed with Reiki Love.\n",
  tags: [],
  msrpDollars: 110,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T23:59:25.726Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
